import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from '../../i18n';
import { LangContext } from '../index';

interface VimeoSectionProps {
  title: string;
  videoId?: string;
  videoUrl?: string;
  primaryButton?: {
    text: string;
    onClick: () => void;
  };
  secondaryButton?: {
    text: string;
    onClick: () => void;
  };
}

export const VimeoSection: React.FC<VimeoSectionProps> = ({
  title,
  videoId,
  videoUrl,
  primaryButton,
  secondaryButton
}) => {
  const { lang } = useContext(LangContext);
  const { t } = useTranslation(lang);

  return (
    <Box
      sx={{
        py: { xs: 2, md: 0 },
        height: 'auto',
        width: '100%',
        position: 'relative',
        scrollSnapAlign: 'start',
        overflow: 'hidden',
        bgcolor: 'transparent'
      }}
    >
      {/* Vidéo en arrière-plan */}
      <Box
        sx={{
          width: '100%',
          maxWidth: { md: '1100px' },
          mx: 'auto',
          px: { xs: 2, md: 3 },
          zIndex: 1,
          '& iframe': {
            width: '100%',
            height: '100%',
            border: 'none'
          }
        }}
      >
        <Box sx={{
          padding: '56.25% 0 0 0',
          position: 'relative',
          width: '100%',
          height: 'auto',
        }}>
          <iframe
            src={videoUrl || `https://player.vimeo.com/video/${videoId}?badge=0&autopause=0&player_id=0&app_id=58479`}
            title={t(title)}
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            loading="lazy"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
